import { loadAllData, syncFirestoreUsersToPouch } from '../redux/actions/local';
import { setMessage } from '../redux/actions/status';

const MIN_INTERVAL_MS = 5 * 60 * 1000;

let inFlight = null;
let lastRunAt = 0;

export const runBackgroundOfflineSync = async (dispatch) => {
    if (typeof dispatch !== 'function') return false;
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return false;
    if (inFlight) return inFlight;
    if (Date.now() - lastRunAt < MIN_INTERVAL_MS) return false;

    inFlight = (async () => {
        try {
            await dispatch(syncFirestoreUsersToPouch());
            await dispatch(loadAllData());
            return true;
        } catch (error) {
            dispatch(setMessage({
                message: `Synchronisation hors ligne interrompue : ${error.message}`,
                status: 'warning',
                timestamp: Date.now()
            }));
            return false;
        } finally {
            lastRunAt = Date.now();
            inFlight = null;
        }
    })();

    return inFlight;
};

export const isBackgroundOfflineSyncRunning = () => inFlight !== null;

export const resetBackgroundOfflineSync = () => {
    lastRunAt = 0;
};